export type RegistrationPageDetails = { title: string; name: string; new: string };

export type UserRegistrationData = Record<RegistrationEntity, RegistrationPageDetails>;

export enum RegistrationEntity {
	Accessory = 'accessory',
	Brand = 'brand',
	Dealership = 'dealership',
	Shopkeeper = 'shopkeeper',
	DealershipGroup = 'dealershipGroup',
	Model = 'model',
	Parameter = 'parameter',
	Type = 'type',
	User = 'user',
	Year = 'year',
}

export const RegistrationEntities: Record<RegistrationEntity, RegistrationPageDetails> = {
	[RegistrationEntity.Accessory]: {
		title: 'Veículos - Acessórios',
		name: 'Acessório',
		new: 'Novo',
	},
	[RegistrationEntity.Brand]: {
		title: 'Veículos - Marcas',
		name: 'Marca',
		new: 'Nova',
	},
	[RegistrationEntity.Dealership]: {
		title: 'Concessionarias',
		name: 'Concessionaria',
		new: 'Nova',
	},
	[RegistrationEntity.Shopkeeper]: {
		title: 'Lojistas',
		name: 'Lojista',
		new: 'Novo',
	},
	[RegistrationEntity.DealershipGroup]: {
		title: 'Concessionarias - Grupos',
		name: 'Grupo',
		new: 'Novo',
	},
	[RegistrationEntity.Model]: {
		title: 'Veículos - Modelos',
		name: 'Modelo',
		new: 'Novo',
	},
	[RegistrationEntity.Parameter]: {
		title: 'Parâmetros Gerais',
		name: 'Parâmetro',
		new: 'Novo',
	},
	[RegistrationEntity.Type]: {
		title: 'Veículos - Tipos',
		name: 'Tipo',
		new: 'Novo',
	},
	[RegistrationEntity.User]: {
		title: 'Usuários',
		name: 'Usuário',
		new: 'Novo',
	},
	[RegistrationEntity.Year]: {
		title: 'Veículos - Anos',
		name: 'Ano',
		new: 'Novo',
	},
};
